import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userDocumentSubmissionsBackend } from './user-document-submissions.backend';
import { userDocumentSubmissionsReducer } from './user-document-submissions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userDocumentSubmissions',
      userDocumentSubmissionsReducer,
    ),
    BackendModule.forFeature(
      'userDocumentSubmissions',
      userDocumentSubmissionsBackend,
    ),
  ],
})
export class DatastoreUserDocumentSubmissionsModule {}
